import { Injectable } from "@angular/core";
import { DisciplineListModel } from "@app/models/shared/discipline.list.model";
import { EnumDiscipline } from "@app/models/dna/dna.discipline.enum";

@Injectable({ providedIn: "root" })
export class DisciplineService {
    public getAllDiscipline(): Array<DisciplineListModel> {
        var enumList = new Array<DisciplineListModel>();
        for (let item in EnumDiscipline) {
            var id = Number(item);
            if (id) {
                let model = new DisciplineListModel();
                model.id = id;
                model.name = EnumDiscipline[id];
                enumList.push(model);
            }
        }
        return enumList;
    }

    public getDisciplineNameFromId(disciplineId: number) {
        return EnumDiscipline[disciplineId];
    }
}
